import React, { useCallback, useEffect, useMemo } from "react";
import { Input, Table } from "antd";
import { useHistory } from "react-router-dom";
import Header from "../../../Components/Header/Header";
import { R_AUDBILITY_USER_DETAILS } from "../../../constants/routes";
import { PAGE_TITLE } from "../shared/constants";
import { getAudbilityUsersColumns } from "./columns";
import { SEARCH_PLACEHOLDER, USERS_PAGE_SIZE } from "./constants";
import { useAudbilityUsers } from "./hooks/useAudbilityUsers";
import classes from "./AudbilityUsers.module.scss";

const { Search } = Input;

const AudbilityUsers = () => {
  const history = useHistory();
  const { users, isLoading, getUsers, searchUsers } = useAudbilityUsers();

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const handleSeeMore = useCallback(
    (record) => history.push(R_AUDBILITY_USER_DETAILS(record.sub)),
    [history]
  );

  const columns = useMemo(
    () => getAudbilityUsersColumns({ users, onSeeMore: handleSeeMore }),
    [users, handleSeeMore]
  );

  return (
    <div className={classes.AudbilityUsersPage}>
      <Header text={PAGE_TITLE} />

      <Search
        className={classes.SearchInput}
        placeholder={SEARCH_PLACEHOLDER}
        onSearch={searchUsers}
      />

      <Table
        className={classes.UsersTable}
        columns={columns}
        dataSource={users}
        loading={isLoading}
        pagination={{
          pageSize: USERS_PAGE_SIZE,
          position: ["bottomRight"],
          showSizeChanger: false,
        }}
        rowKey="sub"
        tableLayout="fixed"
      />
    </div>
  );
};

export default AudbilityUsers;
